export class VideoBlock {
    constructor(element) {
        this.element = element;
        this.id = this.element.dataset.id;
        this.videoId = this.element.dataset.videoId;
        this.videoContainer = this.element.querySelector(`#video-block--${this.id}`);

        this.mobileVideoContainer = this.element.querySelector(`#video-block-mobile--${this.id}`);

        this.init();
    }

    init() {
        this.loadApiScript();

        this.setUpClickEvent();

        window.addEventListener('resize', () => {
            if (typeof player !== 'undefined') {
                player.pauseVideo();
                var video = this.videoContainer;
                video.classList.remove('playing');
                video.style.opacity = 0;
                video.style.zIndex = '-1';
            }
        });

        window.addEventListener('resize', () => {
            if (typeof mobilePlayer !== 'undefined') {
                mobilePlayer.pauseVideo();
            }
        });
    }

    loadApiScript() {
        if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
            return;
        }

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";

        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    setUpClickEvent() {
        const playButton = this.element.querySelector('.video-block__constraint__thumbnail');
        if (playButton) {
            playButton.addEventListener('click', () => {
                const youtubeId = this.videoId;
                this.playVideo(youtubeId);
            });
        }

        const mobilePlayButton = this.element.querySelector('.video-block__constraint__mobile-thumbnail');
        if (mobilePlayButton) {
            mobilePlayButton.addEventListener('click', () => {
                const youtubeId = this.videoId;
                this.playMobileVideo(youtubeId, `video-block-mobile--${this.id}`);
            });
        }
    }

    /**
       * Play video on click
       * @param {object} event 
       */
    onPlayerReady(event) {
        event.target.playVideo();
    }

    /**
        * Show and hide video frame on interaction
        * @param {object} event 
        */
    onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.ENDED) {
            player.seekTo(0)
            player.pauseVideo();
            var video = this.videoContainer;
            video.classList.remove('playing');
            video.style.opacity = 0;
            video.style.zIndex = '-1';
        }
    }

    /**
        * Play video functionality using the youtube iframe API
        * @param {string} youtube_id 
        */
    playVideo(youtube_id) {
        // Update the video elements' visibility
        var video = this.videoContainer;
        video.style.opacity = 1;
        video.style.zIndex = 3;
        video.classList.add('playing');

        // If user has watched the video before play again
        if (typeof player !== 'undefined') {
            player.playVideo();
        }

        // If user has yet to pay the video load up the iframe
        else {
            let player = new YT.Player(this.videoContainer, {
                height: '1080',
                width: '1920',
                videoId: youtube_id,
                playerVars: {
                    'playsinline': 1
                },
                events: {
                    'onReady': this.onPlayerReady,
                    'onStateChange': this.onPlayerStateChange
                }
            });
        }
    }


    /*------------------------------------------------------------------
    Mobile video functionality
    ------------------------------------------------------------------*/
    /**
    * Play video on click
    * @param {object} event
    */
    onMobilePlayerReady(event) {
        event.target.playVideo();
    }

    /**
    * Show and hide video frame on interaction
    * @param {object} event
    */
    onMobilePlayerStateChange(event) {
        if (event.data == YT.PlayerState.ENDED) {
            mobilePlayer.seekTo(0)
            mobilePlayer.pauseVideo();
            var video = this.mobileVideoContainer;
            video.classList.remove('playing');
            video.style.opacity = 0;
            video.style.zIndex = '-1';
        }
    }

    /**
    * Play video functionality using the youtube iframe API
    * @param {string} youtube_id
    */
    playMobileVideo(youtube_id) {
        // Update the video elements' visibility
        var video = this.mobileVideoContainer;
        video.style.opacity = 1;
        video.style.zIndex = 3;
        video.classList.add('playing');

        // If user has watched the video before play again
        if (typeof mobilePlayer !== 'undefined') {
            mobilePlayer.playVideo();
        }

        // If user has yet to pay the video load up the iframe
        else {
            let mobilePlayer = new YT.Player(this.mobileVideoContainer, {
                height: '1080',
                width: '1920',
                videoId: youtube_id,
                playerVars: {
                    'playsinline': 1,
                    'rel': 0,
                },
                events: {
                    'onReady': this.onMobilePlayerReady,
                    'onStateChange': this.onMobilePlayerStateChange
                }
            });
        }
    }

}